import { useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import Autocomplete from '../Autocomplete'

const emptyEntry = { company: '', title: '', startYear: '', endYear: '', current: false }

function toYear(value) {
  const year = Number(value)
  return year > 0 ? year : undefined
}

function ProfessionalStep() {
  const { submitStep } = useAuth()
  const [entries, setEntries] = useState([{ ...emptyEntry }])
  const [error, setError] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const updateEntry = (index, key, value) => {
    setEntries(entries.map((entry, i) => (i === index ? { ...entry, [key]: value } : entry)))
  }

  const addEntry = () => setEntries([...entries, { ...emptyEntry }])

  const removeEntry = (index) => setEntries(entries.filter((_, i) => i !== index))

  const save = async (payload) => {
    setError('')
    setSubmitting(true)
    try {
      await submitStep(payload)
    } catch (err) {
      setError(err.message)
      setSubmitting(false)
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const experience = entries
      .filter((entry) => entry.company.trim())
      .map((entry) => ({
        company: entry.company,
        title: entry.title,
        startYear: toYear(entry.startYear),
        endYear: entry.current ? undefined : toYear(entry.endYear),
        current: entry.current,
      }))
    save({ experience })
  }

  return (
    <form className="onb-form" onSubmit={handleSubmit}>
      <h1 className="onb-title">Your experience</h1>
      <p className="onb-sub">Add roles you've held. You can skip this.</p>

      {error && <div className="onb-error">{error}</div>}

      {entries.map((entry, index) => (
        <div className="onb-entry" key={index}>
          {entries.length > 1 && (
            <button type="button" className="onb-remove" onClick={() => removeEntry(index)}>
              Remove
            </button>
          )}
          <label className="onb-label">
            Company / firm
            <Autocomplete
              type="firm"
              value={entry.company}
              onChange={(value) => updateEntry(index, 'company', value)}
              placeholder="Start typing..."
            />
          </label>
          <label className="onb-label">
            Title
            <input
              className="onb-input"
              value={entry.title}
              onChange={(event) => updateEntry(index, 'title', event.target.value)}
            />
          </label>
          <div className="onb-row">
            <label className="onb-label">
              Start year
              <input
                className="onb-input"
                type="number"
                value={entry.startYear}
                onChange={(event) => updateEntry(index, 'startYear', event.target.value)}
              />
            </label>
            <label className="onb-label">
              End year
              <input
                className="onb-input"
                type="number"
                value={entry.endYear}
                onChange={(event) => updateEntry(index, 'endYear', event.target.value)}
                disabled={entry.current}
              />
            </label>
          </div>
          <label className="onb-check">
            <input
              type="checkbox"
              checked={entry.current}
              onChange={(event) => updateEntry(index, 'current', event.target.checked)}
            />
            I currently work here
          </label>
        </div>
      ))}

      <button type="button" className="onb-add" onClick={addEntry}>
        + Add another
      </button>

      <div className="onb-actions">
        <button type="button" className="onb-skip" onClick={() => save({ experience: [] })} disabled={submitting}>
          Skip for now
        </button>
        <button type="submit" className="onb-submit" disabled={submitting}>
          {submitting ? 'Saving...' : 'Finish'}
        </button>
      </div>
    </form>
  )
}

export default ProfessionalStep
